import { Fragment } from 'react';
import { Button, Glyphicon } from 'react-bootstrap';
import { checkSquareO } from 'react-icons-kit/fa/checkSquareO';
import { squareO } from 'react-icons-kit/fa/squareO';
import { ISettings } from './models/index';
import { IconWrapper, ButtonWrapper } from './styles';

interface IProps {
    settings: ISettings,
    inverted: boolean,
    onShowSideBar: () => void,
    onShowHideSection: (section: string) => void,
    onShowHideEmpty: (section: string) => void
}

const Settings = (props: IProps) => {
    const sections = [{ label: 'To-Do', name: 'todo' }, { label: 'Other', name: 'other' }, { label: 'Compliance', name: 'compliance' }];
    const color = props.inverted ? '#FFF' : '#333';
    const backgroundColor = props.inverted ? '#000' : '#FFF';

    return (
        <div style={{ height: '100%', color, backgroundColor, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div style={{ padding: '10px 10px 10px 20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <h2>TO-DO Settings</h2>
                    <Button bsStyle='link' bsSize='sm' style={{ color }} onClick={props.onShowSideBar}><Glyphicon glyph='remove' /></Button>
                </div>

                <div className='text-left' style={{ height: '80%', paddingLeft: 40 }}>
                    {sections.map((section, index) =>
                        <Fragment key={'ac-section-' + index}>
                            <h4>{section.label.toUpperCase()}</h4>
                            <ButtonWrapper style={{ color }} bsStyle='link' onClick={() => props.onShowHideSection(section.name)}>
                                <IconWrapper icon={props.settings[section.name].hide ? checkSquareO : squareO} style={{ marginRight: 3, verticalAlign: 'middle' }} />Hide Section
                            </ButtonWrapper><br />
                            <ButtonWrapper style={{ color }} bsStyle='link' onClick={() => props.onShowHideEmpty(section.name)}>
                                <IconWrapper icon={props.settings[section.name].hideEmptyItems ? checkSquareO : squareO} style={{ marginRight: 3, verticalAlign: 'middle' }} />Hide Empty Items
                            </ButtonWrapper>
                        </Fragment>
                    )}
                </div>
            </div>

            <div className='text-center' style={{ color, backgroundColor }}>
                <Button bsStyle='link' style={{ color }} block onClick={props.onShowSideBar}>Close Settings</Button>
            </div>
        </div>
    );
}

export default Settings;